import React from 'react'

type Props = {
  color?: 'white'
}

const YandexRuLogo: React.FC<Props> = ({color}) => {
  const fill = color === 'white' ? '#fff' : '#21201F'

  return (
    <svg fill={fill} height="30" viewBox="0 0 31 12" width="90" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.46144 1.18104H1.34082L1.31363 7.39338L0.171753 10.8326H2.31957L3.40707 7.5565L7.56675 1.18104H5.16066L3.78769 3.70947C3.52941 4.17166 3.3255 4.59307 3.25753 4.75619C3.28472 4.57947 3.3255 4.03572 3.35269 3.58713L3.46144 1.18104Z"
        fill="white"
      />
      <path
        d="M3.17725 10.8326H5.36584L6.18146 9.0926H7.90787L7.60881 10.8326H9.67506L11.0752 1.18104H8.17975L3.17725 10.8326ZM8.23412 7.27104H7.05146L8.506 4.17166C8.73709 3.69588 8.91381 3.26088 8.98178 3.09775C8.95459 3.27447 8.84584 3.80463 8.76428 4.25322L8.23412 7.27104Z"
        fill="white"
      />
      <path
        d="M15.4221 1.18104H13.084L9.87589 10.8326H11.847L13.5054 5.78932C13.6821 5.28635 13.8045 4.83775 13.8589 4.67463C13.8453 4.85135 13.7909 5.3951 13.7637 5.84369L13.4646 10.8326H15.7484L18.9565 1.18104H16.9854L15.4085 5.97963C15.2318 6.4826 15.1095 6.93119 15.0551 7.09432C15.0687 6.9176 15.1095 6.37385 15.1367 5.92525L15.4221 1.18104Z"
        fill="white"
      />
      <path
        d="M21.3311 7.18947L21.2903 7.31182C20.9912 8.2226 20.5018 9.24213 19.9037 9.24213C19.224 9.24213 19.4823 7.62447 20.0532 5.88447C20.8553 3.4376 21.3447 2.74432 21.902 2.74432C22.2147 2.74432 22.4186 3.05697 22.4865 4.15807L24.4032 3.51916C24.3217 2.119 23.6556 0.990723 22.1059 0.990723C20.3251 0.990723 18.9114 2.49963 17.919 5.53104C17.0082 8.31775 17.0898 10.9006 19.0065 10.9006C19.6726 10.9006 20.1348 10.6423 20.6106 10.0578L20.4747 10.8326H22.0107L23.8323 5.36791H20.8961L20.2979 7.18947H21.3311Z"
        fill="white"
      />
      <path
        d="M25.898 11.0093C27.5701 11.0093 29.0382 9.514 30.0169 6.4826C30.9277 3.69588 30.9141 1.00432 28.2905 1.00432C26.6185 1.00432 25.1504 2.49963 24.1716 5.53104C23.2608 8.31775 23.2744 11.0093 25.898 11.0093ZM26.1155 9.28291C25.2999 9.28291 25.7757 7.48854 26.3058 5.88447C27.1079 3.39682 27.6108 2.73072 28.073 2.73072C28.8751 2.73072 28.4129 4.49791 27.8827 6.12916C27.0807 8.61682 26.5777 9.28291 26.1155 9.28291Z"
        fill="white"
      />
    </svg>
  )
}

export default YandexRuLogo
